<template>
	<router-view :key="$route.path" name="default" />
</template>

<script>
	import 'cabells-design-system/src/assets/css/ds/1.0/twglobal.css';
	import screens from 'cabells-design-system/design-system-config/1.0.0/screens.config';
	import '@/assets/css/tooltips.css';
	import { computed } from 'vue';

	export default {
		name: 'App',
		mounted() {
			const url = new URL(window.location);
			const utm_source = url.searchParams.getAll("utm_source");
			sessionStorage.setItem("utm_source", utm_source);
			const utm_medium = url.searchParams.getAll("utm_medium");
			sessionStorage.setItem("utm_medium", utm_medium);
			const utm_campaign = url.searchParams.getAll("utm_campaign");
			sessionStorage.setItem("utm_campaign", utm_campaign);
			this.$router.replace({
				path: url.pathname,
				query: {
					...this.$route.query,
					utm_source: undefined,
					utm_medium: undefined,
					utm_campaign: undefined
				}
			});
			let i;
			for (i in screens) {
				const min = screens[i].min;
				const max = screens[i]?.max;
				let mediaQuery = '(min-width:' + min + ')';
				mediaQuery += (max) ? ' and (max-width:' + max + ')' : '';
				const mediaQueryList = window.matchMedia(mediaQuery);
				this.breakpointCallback(mediaQueryList, i);
				mediaQueryList.addEventListener('change', this.breakpointCallback.bind(mediaQueryList, mediaQueryList, i));
			}
		},
		provide() {
			return {
				currentBreakpoint: computed(() => this.currentBreakpoint),
			}
		},
		data() {
			return {
				currentBreakpoint: '',
			}
		},
		methods: {
			breakpointCallback(mediaQueryList, breakpointName) {
				if (mediaQueryList.matches) {
					this.currentBreakpoint = breakpointName;
				}
			},
		},
	}
</script>